import './services';
import { signin } from './libs/auth';
import * as SNS from './libs/sns';

(async () => {
  await SNS.config();
  const user = await SNS.openid({ info: false });

  if (!user) {
    return;
  }

  const signinPromise = signin(user);
  const snsConfigPromise = SNS.init();

  Promise.all([
    import('react'),
    import('react-dom'),
    import('react-redux'),
    import('moment'),
    import('moment/locale/zh-cn'),
    import('react-router'),
    import('react-router-redux'),
    import('node.date-time'),
  ]);

  await Promise.all([signinPromise, snsConfigPromise]);
  await import('./render');
})();
